"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const DateDisplay = _ref => {
  let {
    date,
    format,
    fromNow,
    timezone
  } = _ref,
      props = _objectWithoutProperties(_ref, ["date", "format", "fromNow", "timezone"]);

  const getFormattedDate = () => {
    if (timezone && !fromNow) {
      return (0, _momentTimezone.default)(date).tz(timezone).format(format);
    }

    if (fromNow) {
      return (0, _moment.default)(date).fromNow();
    }

    return (0, _moment.default)(date).format(format);
  };

  return /*#__PURE__*/_react.default.createElement("time", _extends({
    dateTime: (0, _moment.default)(date).format('YYYY-MM-DD')
  }, props), getFormattedDate());
};

DateDisplay.propTypes = {
  date: _propTypes.default.string.isRequired,
  format: _propTypes.default.string,
  fromNow: _propTypes.default.bool,
  timezone: _propTypes.default.string
};
DateDisplay.defaultProps = {
  format: 'YYYY/MM/DD',
  fromNow: false,
  timezone: undefined
};
var _default = DateDisplay;
exports.default = _default;